import { useEffect } from "react";
import { Modal, Button } from "react-bootstrap";

export const TableViewAdd = ({ title, showState, addAction, invalid, children }) => {
  const [show, setShow] = showState;

  // eslint-disable-next-line
  const handleKey = (event) => {
    if (show && event.altKey && event.key === "s" && invalid === "") {
      addAction();
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [handleKey])

  return <Modal show={show} onHide={() => setShow(false)} animation={false} size="xl">
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title><br />
    </Modal.Header>
    <Modal.Body>
      {children}
    </Modal.Body>
    <Modal.Footer>
      <span style={{ color: "red" }}>{invalid}</span>
      <Button variant="primary" onClick={addAction} disabled={invalid !== ""}>
        Save
        <sup style={{ "textDecoration": invalid !== "" ? "line-through" : "" }}>(Alt+s)</sup>
      </Button>
    </Modal.Footer>
  </Modal>
}

export const defaultResetAdd = (form, defaultOverride) => {
  return async () => {
    for (const key in form) {
      const [, setVal] = form[key]
      if (defaultOverride !== undefined) {
        setVal(
          key in defaultOverride
            ? (typeof (defaultOverride[key]) === 'function' ? defaultOverride[key]() : defaultOverride[key])
            : null
        );
      } else {
        setVal(null)
      }
    }
  }
}

export const defaultAdd = (form, addMethod, updateMethod, resetMethod, setShow) => {
  return async () => {
    const submitForm = {}
    for (const key in form) {
      submitForm[key] = form[key][0];
    }
    const result = await addMethod(submitForm);
    setTimeout(async () => { await updateMethod() }, 200);
    resetMethod();
    setShow(false);
    return result;
  };
}

export const defaultValidateAdd = (error) => {
  for (const key of Object.keys(error)) {
    if (error[key][0] !== "") return `Form contains errors! (${key}: "${error[key][0]}")`;
  }
  return ""
}

export default TableViewAdd
